import { render, staticRenderFns } from "./serviceReview.vue?vue&type=template&id=a1d8f302&"
import script from "./serviceReview.vue?vue&type=script&lang=js&"
export * from "./serviceReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports